<fieldset [formGroup]="group" class="w-100 in-one-column">
  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-textarea
        formControlName="descriptionOfUsage"
        [label]="TITLE + 'DESCRIPTION_OF_USAGE' | translate"
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>

    <mat-form-field>
      <app-easy-textarea
        formControlName="descriptionOfStorage"
        [label]="TITLE + 'DESCRIPTION_OF_STORAGE' | translate"
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>
  </div>

  <ng-container *ngIf="getCtrl('specialProperties')">
    <app-special-properties-subform
      [groupName]="'specialProperties'"
      class="w-100"
      [readOnly]="readOnly"
    ></app-special-properties-subform>
  </ng-container>
</fieldset>
